import React, { Component, createContext } from 'react';
import queryString from 'query-string'
import { createBrowserHistory } from 'history'
import fbImage from '../assets/images/smartid-quiz-ogimage.png'

// create the context
export const AppConsumer = createContext();

const history = createBrowserHistory();
// create a provider
export class AppProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: 'en',
      correctAnswers: null,
      mobile: false,
      finished: false
    }
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    const location = window.location.href;
    const imageUrl = location.slice('/', -1) + fbImage;
    const values = queryString.parse(history.location.search);
    if (values.lang) {
      this.setState({ ...this.state, locale: values.lang })
    }
    const tags = [
      {
          name: 'og:title',
          value: 'Smart-ID Quiz'
      },
      {
          name: 'og:url',
          value: location
      },
      {
          name: 'og:image',
          value: imageUrl
      },
    ]
    tags.forEach(tag => {
        const metaExists = document.querySelector(`meta[property="${tag.name}"]`);
        if (!metaExists) {
            this.insertTag(tag);
        }
    })
  }
  insertTag = ({ name, value }) => {
      let tag = document.createElement('meta');
      tag.setAttribute('property', name);
      tag.content = value;
      document.getElementsByTagName('head')[0].appendChild(tag);
  }
  handleResize = () => {
    const width = window.innerWidth;
    if (width <= 800) {
      this.setState({ mobile: true })
    } else {
      this.setState({ mobile: false })
    }
  }
  switchLanguage = (lang) => {
    this.setState({ ...this.state, locale: lang });
  }
  setFinished = () => {
    this.setState({ ...this.state, finished: true });
  }
  setCorrectAnswers = (count) => {
    this.setState({ correctAnswers: count });
  }
  render() {
    const { locale, correctAnswers, mobile, finished } = this.state;
    const { children } = this.props;

    const configObject = {
      locale, 
      correctAnswers,
      finished,
      setFinished: this.setFinished,
      switchLanguage: this.switchLanguage,
      setCorrectAnswers: this.setCorrectAnswers,
      mobile
    };

    return (
      <AppConsumer.Provider value={configObject}>
        {children}
      </AppConsumer.Provider>
    );
  }
}